import React, { useState } from 'react'
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import axios from 'axios'

const useStyles = makeStyles(() => ({
  errorText: {
    color: '#c62828',
    fontSize: '0.8rem',
    marginTop: 4
  }
}))

export default function MapOfferingDialog ({ open, offering, onClose, onMapped }) {
  const classes = useStyles()
  const [catalogId, setCatalogId] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  const handleClose = () => {
    if (saving) return
    setCatalogId('')
    setError('')
    onClose()
  }

  const handleSubmit = async () => {
    if (!catalogId.trim()) { setError('Aspire Catalog Item ID is required'); return }
    setSaving(true)
    setError('')
    try {
      await axios.post(`/api/aggregate-dashboard/offerings/${offering._id}/map`, {
        aspireCatalogItemId: catalogId.trim()
      })
      setCatalogId('')
      onMapped()
    } catch (err) {
      const msg = err.response && err.response.data && err.response.data.error
        ? err.response.data.error
        : err.message
      setError(msg)
    } finally {
      setSaving(false)
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        Map to Aspire Catalog Item
        {offering && (
          <Typography variant="caption" display="block" color="textSecondary" style={{ marginTop: 2 }}>
            {offering.productTitle}
            {offering.variantTitle ? ` \u2014 ${offering.variantTitle}` : ''}
          </Typography>
        )}
      </DialogTitle>
      <DialogContent>
        <TextField
          label="Aspire Catalog Item ID *"
          value={catalogId}
          onChange={(e) => { setCatalogId(e.target.value); setError('') }}
          variant="outlined"
          size="small"
          fullWidth
          placeholder="MongoDB ObjectId"
          autoFocus
          style={{ marginTop: 8 }}
        />
        {error && (
          <Typography className={classes.errorText}>{error}</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={saving}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          disabled={saving}
        >
          {saving ? <CircularProgress size={18} /> : 'Save Mapping'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
